// [AUTH0 COMMENTED OUT] import { useAuth0 } from '@auth0/auth0-react';
import { Redirect, Route } from 'react-router';
import React from 'react';
// [AUTH0 COMMENTED OUT] import Loader from '../components/atoms/Loader';
import { getCookie, isTokenExpired } from '../utils/cookieUtils';

const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || 'https://login.peoplelens.ai';

type Props = {
  component: React.FC;
  path: string;
  exact: boolean;
};

const PrivateRoute: React.FC<Props> = (props: Props) => {
  // [AUTH0 COMMENTED OUT] — replaced Auth0 isAuthenticated check with cookie-based check
  // const { isAuthenticated, isLoading } = useAuth0();
  // return isLoading ? (
  //   <Loader />
  // ) : isAuthenticated ? (
  //   <Route path={props.path} exact={props.exact} component={props.component} />
  // ) : (
  //   <Redirect to="/" />
  // );

  const token = getCookie('accessToken');
  const isAuthenticated = token && !isTokenExpired(token);

  if (isAuthenticated) {
    return <Route path={props.path} exact={props.exact} component={props.component} />;
  }

  // Not authenticated — redirect to the newlogin portal
  window.location.href = LOGIN_URL;
  return null;
};

export default PrivateRoute;
